export const range: {
    (count: number): number[];
    (start: number, end: number): number[];
} = (start: number, end?: number) => {
    if (end == null) {
        end = start - 1;
        start = 0;
    }

    const rng = [];

    for (let i = start; i <= end; i++) {
        rng.push(i);
    }

    return rng;
};

export const areArraysEqual = (first: unknown[], second: unknown[]) => {
    if (first.length !== second.length) {
        return false;
    }

    for (let i = 0; i < first.length; i++) {
        if (first[i] !== second[i]) {
            return false;
        }
    }

    return true;
};

export const removeDuplicates = (arr) => {
    const seen = {};
    const result = [];

    for (const item of arr) {
        if (!seen[item]) {
            seen[item] = true;
            result.push(item);
        }
    }

    return result;
};
